import React from 'react'
import styled from 'styled-components'
import ParseContent from 'components/shared/ParseContent'
import ButtonSlide from 'components/elements/ButtonSlide'

const StyledWebinars = styled.section`
  position: relative;
  z-index: 1;

  @media screen and (min-width: 992px) {
    padding-top: 100px;
    padding-bottom: 100px;
  }

  @media screen and (max-width: 991px) {
    padding-top: 60px;
    padding-bottom: 60px;
  }

  @media screen and (max-width: 576px) {
    padding-top: 40px;
    padding-bottom: 40px;
  }
`

const StyledContainer = styled.div`
  height: 100%;

  @media screen and (max-width: 991px) {
    height: unset;
    position: relative;
  }
`

const Wrapper = styled.div``

const TitleBlock = styled.div`
  & h2 {
    font-weight: ${(props) => props.theme.font.weight.xl};

    @media screen and (min-width: 992px) {
      font-size: ${(props) => props.theme.font.size.xl};
    }

    @media screen and (max-width: 991px) {
      font-size: ${(props) => props.theme.font.size.l};
    }
  }
`

const HeaderBlock = styled.div``

const DescriptionBlock = styled.div`
  max-width: 50%;
  margin-top: 16px;

  @media screen and (max-width: 991px) {
    max-width: 100%;
    margin-top: 12px;
  }

  @media screen and (max-width: 576px) {
    margin-top: 8px;
  }
`

const ItemsBlock = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 48px;
  margin-top: 40px;

  @media screen and (max-width: 991px) {
    gap: 32px;
    margin-top: 32px;
  }

  @media screen and (max-width: 767px) {
    grid-template-columns: 1fr;
    gap: 24px;
    margin-top: 24px;
  }

  @media screen and (max-width: 576px) {
    gap: 20px;
    margin-top: 20px;
  }
`

const WebinarItem = styled.div`
  background-color: ${(props) => props.theme.color.face.light};
  border-radius: 20px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.3);
  padding: 40px 50px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  & h3 {
    font-weight: ${(props) => props.theme.font.weight.xl};

    @media screen and (min-width: 992px) {
      font-size: ${(props) => props.theme.font.size.l};
    }

    @media screen and (max-width: 991px) {
      font-size: ${(props) => props.theme.font.size.xm};
    }
  }

  @media screen and (max-width: 991px) {
    padding: 28px;
    border-radius: 16px;
  }

  @media screen and (max-width: 576px) {
    padding: 20px;
    border-radius: 12px;
  }
`

const DateSvg = ({ clipId }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 12C24 18.6272 18.6272 24 12 24C5.37285 24 0 18.6272 0 12C0 5.37285 5.37285 0 12 0C18.6272 0 24 5.37285 24 12Z"
      fill="#3B5998"
    />
    <g clipPath={`url(#${clipId})`}>
      <path
        d="M4.94118 16.1178C4.94211 16.8976 5.25228 17.6452 5.80366 18.1965C6.35503 18.7479 7.10259 19.0581 7.88235 19.059H16.1176C16.8974 19.0581 17.645 18.7479 18.1963 18.1965C18.7477 17.6452 19.0579 16.8976 19.0588 16.1178V10.8237H4.94118V16.1178ZM14.9412 13.4708C15.1157 13.4708 15.2863 13.5225 15.4314 13.6195C15.5765 13.7164 15.6896 13.8543 15.7564 14.0155C15.8231 14.1767 15.8406 14.3541 15.8066 14.5253C15.7725 14.6964 15.6885 14.8537 15.5651 14.9771C15.4417 15.1005 15.2845 15.1845 15.1133 15.2185C14.9422 15.2526 14.7647 15.2351 14.6035 15.1683C14.4423 15.1015 14.3045 14.9885 14.2075 14.8434C14.1106 14.6982 14.0588 14.5277 14.0588 14.3531C14.0588 14.1191 14.1518 13.8947 14.3173 13.7292C14.4827 13.5638 14.7072 13.4708 14.9412 13.4708ZM12 13.4708C12.1745 13.4708 12.3451 13.5225 12.4902 13.6195C12.6353 13.7164 12.7484 13.8543 12.8152 14.0155C12.882 14.1767 12.8994 14.3541 12.8654 14.5253C12.8314 14.6964 12.7473 14.8537 12.6239 14.9771C12.5005 15.1005 12.3433 15.1845 12.1721 15.2185C12.001 15.2526 11.8236 15.2351 11.6623 15.1683C11.5011 15.1015 11.3633 14.9885 11.2664 14.8434C11.1694 14.6982 11.1176 14.5277 11.1176 14.3531C11.1176 14.1191 11.2106 13.8947 11.3761 13.7292C11.5416 13.5638 11.766 13.4708 12 13.4708ZM9.05882 13.4708C9.23334 13.4708 9.40393 13.5225 9.54903 13.6195C9.69414 13.7164 9.80723 13.8543 9.87401 14.0155C9.9408 14.1767 9.95827 14.3541 9.92422 14.5253C9.89018 14.6964 9.80614 14.8537 9.68274 14.9771C9.55934 15.1005 9.40212 15.1845 9.23096 15.2185C9.0598 15.2526 8.88239 15.2351 8.72116 15.1683C8.55993 15.1015 8.42213 14.9885 8.32517 14.8434C8.22822 14.6982 8.17647 14.5277 8.17647 14.3531C8.17647 14.1191 8.26943 13.8947 8.43491 13.7292C8.60038 13.5638 8.82481 13.4708 9.05882 13.4708V13.4708Z"
        fill="white"
      />
      <path
        d="M16.1176 6.11788H15.5294V5.52964C15.5294 5.37363 15.4674 5.22401 15.3571 5.1137C15.2468 5.00338 15.0972 4.94141 14.9412 4.94141C14.7852 4.94141 14.6355 5.00338 14.5252 5.1137C14.4149 5.22401 14.3529 5.37363 14.3529 5.52964V6.11788H9.64706V5.52964C9.64706 5.37363 9.58509 5.22401 9.47477 5.1137C9.36445 5.00338 9.21483 4.94141 9.05882 4.94141C8.90281 4.94141 8.7532 5.00338 8.64288 5.1137C8.53256 5.22401 8.47059 5.37363 8.47059 5.52964V6.11788H7.88235C7.10259 6.11881 6.35503 6.42898 5.80366 6.98036C5.25228 7.53173 4.94211 8.27929 4.94118 9.05905L4.94118 9.64729H19.0588V9.05905C19.0579 8.27929 18.7477 7.53173 18.1963 6.98036C17.645 6.42898 16.8974 6.11881 16.1176 6.11788V6.11788Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id={clipId}>
        <rect
          width="14.1176"
          height="14.1176"
          fill="white"
          transform="translate(4.94118 4.94141)"
        />
      </clipPath>
    </defs>
  </svg>
)

const TimeSvg = ({ clipId }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 12C24 18.6272 18.6272 24 12 24C5.37285 24 0 18.6272 0 12C0 5.37285 5.37285 0 12 0C18.6272 0 24 5.37285 24 12Z"
      fill="#3B5998"
    />
    <g clipPath={`url(#${clipId})`}>
      <path
        d="M12 4.94141C10.6039 4.94141 9.23915 5.3554 8.07833 6.13103C6.91751 6.90667 6.01277 8.0091 5.4785 9.29894C4.94424 10.5888 4.80445 12.0081 5.07681 13.3773C5.34918 14.7466 6.02147 16.0044 7.00866 16.9916C7.99586 17.9788 9.25362 18.6511 10.6229 18.9234C11.9922 19.1958 13.4115 19.056 14.7013 18.5217C15.9911 17.9875 17.0936 17.0827 17.8692 15.9219C18.6448 14.7611 19.0588 13.3963 19.0588 12.0002C19.0588 10.1281 18.3151 8.33267 16.9913 7.00889C15.6676 5.6851 13.8721 4.94141 12 4.94141V4.94141ZM12.5882 12.2549L9.61589 14.1179L8.99177 13.1179L11.4118 11.6032V8.47082H12.5882V12.2549Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id={clipId}>
        <rect
          width="14.1176"
          height="14.1176"
          fill="white"
          transform="translate(4.94118 4.94141)"
        />
      </clipPath>
    </defs>
  </svg>
)

const PinSvg = ({ clipId }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 12C24 18.6272 18.6272 24 12 24C5.37285 24 0 18.6272 0 12C0 5.37285 5.37285 0 12 0C18.6272 0 24 5.37285 24 12Z"
      fill="#3B5998"
    />
    <g clipPath={`url(#${clipId})`}>
      <path
        d="M12 4.96631C10.4435 4.96802 8.95121 5.58706 7.85054 6.68762C6.74987 7.78818 6.13068 9.28039 6.12881 10.8369C6.12881 12.3487 7.2994 14.7145 9.60823 17.8687C9.88309 18.2452 10.243 18.5515 10.6586 18.7627C11.0742 18.9739 11.5338 19.084 12 19.084C12.4662 19.084 12.9258 18.9739 13.3414 18.7627C13.757 18.5515 14.1169 18.2452 14.3918 17.8687C16.7006 14.7145 17.8712 12.3487 17.8712 10.8369C17.8693 9.28039 17.2501 7.78818 16.1494 6.68762C15.0488 5.58706 13.5565 4.96802 12 4.96631V4.96631ZM12 13.1769C11.5346 13.1769 11.0797 13.0389 10.6928 12.7804C10.3058 12.5218 10.0042 12.1543 9.82616 11.7244C9.64807 11.2944 9.60147 10.8213 9.69226 10.3649C9.78305 9.90849 10.0071 9.48924 10.3362 9.16018C10.6653 8.83111 11.0845 8.60702 11.541 8.51623C11.9974 8.42544 12.4705 8.47203 12.9004 8.65012C13.3304 8.82821 13.6978 9.12979 13.9564 9.51673C14.2149 9.90367 14.3529 10.3586 14.3529 10.824C14.3529 11.448 14.105 12.0465 13.6638 12.4877C13.2225 12.929 12.624 13.1769 12 13.1769Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id={clipId}>
        <rect
          width="14.1176"
          height="14.1176"
          fill="white"
          transform="translate(4.94118 4.94141)"
        />
      </clipPath>
    </defs>
  </svg>
)

const WebinarLabel = styled.div`
  color: ${(props) => props.theme.color.text.secondary};

  @media screen and (min-width: 577px) {
    font-size: ${(props) => props.theme.font.size.sm};
  }

  @media screen and (max-width: 576px) {
    font-size: ${(props) => props.theme.font.size.xs};
  }
`

const WebinarMeta = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media screen and (max-width: 576px) {
    gap: 10px;
  }
`

const WebinarDate = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  & > svg {
    flex-shrink: 0;
  }

  @media screen and (max-width: 576px) {
    gap: 6px;
    font-size: ${(props) => props.theme.font.size.sm};
  }
`

const WebinarTime = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  & > svg {
    flex-shrink: 0;
  }

  @media screen and (max-width: 576px) {
    gap: 6px;
    font-size: ${(props) => props.theme.font.size.sm};
  }
`

const WebinarDescription = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;

  & > svg {
    flex-shrink: 0;
  }

  @media screen and (max-width: 576px) {
    gap: 6px;
  }
`

const ButtonWrap = styled.div`
  @media screen and (max-width: 767px) {
    width: 100%;

    & > * {
      width: 100%;
      display: block;
      text-align: center;
    }

    & a,
    & button {
      display: block;
      width: 100%;
      text-align: center;
    }
  }
`

const Webinars = ({ className = '', content, id = 'webinars' }) => {
  if (!content) return null
  const webinars = [
    'https://events.teams.microsoft.com/event/65b764ba-1625-4726-9950-5a2393405b10@fbb995eb-baed-4b79-bd48-18b7fb207dd2',
    'https://events.teams.microsoft.com/event/5ace7571-ac4d-4bf9-8c66-e2cce47352c1@fbb995eb-baed-4b79-bd48-18b7fb207dd2',
  ]
  return (
    <StyledWebinars id={id} className={`${className}`}>
      <StyledContainer className="container">
        <Wrapper>
          <HeaderBlock className="pb-1">
            <TitleBlock>
              <h2>{content?.title}</h2>
            </TitleBlock>
            <DescriptionBlock className="mt-1">
              <ParseContent content={content?.description} compactLineHeight />
            </DescriptionBlock>
          </HeaderBlock>
          <ItemsBlock className="mt-3 mt-lg-4">
            {content?.items?.map((item, index) => (
              <WebinarItem key={index}>
                <div>
                  <WebinarLabel>Webinar</WebinarLabel>
                  <h3 className="mt-1">{item.title}</h3>
                  <WebinarMeta className="mt-4">
                    <WebinarDate>
                      <DateSvg clipId={`webinar-date-${index}`} />
                      <span>{item?.date}</span>
                    </WebinarDate>
                    <WebinarTime>
                      <TimeSvg clipId={`webinar-time-${index}`} />
                      <span>{item?.time}</span>
                    </WebinarTime>
                    <WebinarDescription>
                      <PinSvg clipId={`webinar-pin-${index}`} />
                      <span>
                        <ParseContent
                          content={item.description}
                          compactLineHeight
                        />
                      </span>
                    </WebinarDescription>
                  </WebinarMeta>
                </div>
                <ButtonWrap className="mt-4 d-lg-flex">
                  <ButtonSlide
                    icon="arrow"
                    defaultSize
                    to={webinars[index]}
                    isAnchor
                    external
                  >
                    Meld je gratis aan
                  </ButtonSlide>
                </ButtonWrap>
              </WebinarItem>
            ))}
          </ItemsBlock>
        </Wrapper>
      </StyledContainer>
    </StyledWebinars>
  )
}

export default Webinars
